<template>
    <div class="flex md:items-center justify-center h-screen">
        <div v-if="!isDeactivated" class="max-w-3xl mx-auto bg-white p-10 md:h-fit h-full relative">
            <div v-if="organization" class="flex flex-row justify-between items-center mb-6">
                <h2 class="text-left lg:text-body-1 md:text-body-2 text-body-3 font-medium text-default-1">
                    You are not part of the <span class="font-black">{{ organization.name }}</span> organization
                </h2>
                <img v-if="organization.theme_settings && organization.theme_settings.logo"
                     :src="useImagePathFormatter(organization.slug, organization.theme_settings.logo)"
                     class="object-contain w-20 h-20 rounded-full"
                     alt="logo"
                />
                <DefaultOrgIcon v-else/>
            </div>
            <div class="mb-10">
                <p class="text-body-5 text-d1efault-2 font-normal">Click Request Access to the organization. If you've arrived here by mistake, please head to the Launchpad to explore all available organizations.</p>
            </div>
            <div class="md:w-2/3">
                <div class="mt-10 flex">
                    <CoreButton
                        :disabled="buttonLoader"
                        button-type="primary"
                        @click="doSubmit"
                        label="Request access"
                        :loading="buttonLoader"
                    />
                    <CoreButton
                        class="ml-4"
                        :disabled="buttonLoader"
                        button-type="ghost"
                        @click="goToLaunchpad"
                        label="Launchpad"
                        :loading="buttonLoader"
                    />
                </div>
            </div>
        </div>
        <div v-else class="max-w-3xl mx-auto bg-white p-10 md:h-fit h-full relative">
            <div v-if="organization" class="flex flex-row justify-between items-center mb-6">
                <h2 class="text-left lg:text-body-1 md:text-body-2 text-body-3 font-medium text-default-1">
                    Your membership has been deactivated from the <span class="font-black">{{ organization.name }}</span> organization
                </h2>
                <img v-if="organization.theme_settings && organization.theme_settings.logo"
                     :src="useImagePathFormatter(organization.slug, organization.theme_settings.logo)"
                     class="object-contain w-20 h-20 rounded-full"
                     alt="logo"
                />
                <DefaultOrgIcon v-else/>
            </div>
            <div class="mb-10">
                <p class="text-body-5 text-d1efault-2 font-normal">
                    Please contact the organization admin to reactivate your membership.
                </p>
            </div>
        </div>
    </div>
</template>

<script setup>
import {useAuth} from "@/stores/AuthStore";
import {storeToRefs} from "pinia";
import {useImagePathFormatter} from "@/composables/useImagePathFormatter";
import DefaultOrgIcon from "@/components/icons/small/DefaultOrgIcon.vue";
import {useRouter} from "vue-router";
import {ref} from "vue";
import {useUsers} from "@/composables/useUsers";
import CoreButton from '@/components/core/Button.vue';
import {toast} from "vue3-toastify";

const router = useRouter();

const {organization, user} = storeToRefs(useAuth());
const {init} = useAuth();
const {createMembership} = useUsers();

const isDeactivated = ref(false);
const buttonLoader = ref(false);

async function doSubmit() {
    buttonLoader.value = true;

    try {
        await createMembership(organization.value.uid, user.value.uid)

        await init(organization.value.slug)
        router.push('onboarding');
    } catch (e) {
        if(e.response.status === 409) {
            isDeactivated.value = true;
        } else {
            toast.error('Something went wrong. Please try again later');
        }
    } finally {
        buttonLoader.value = false;
    }
}

function goToLaunchpad() {
    router.push('launchpad');
}

</script>
